import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "../css/ModalIframe.css";

export default function ModalIframe({
  iFrameKey,
  url,
  error,
  show,
  closeModal,
  mensaje,
}) {
  const [showModal, setShowModal] = useState(show);

  useEffect(() => {
    if (url) {
      window.frames.__fsov_Iframe.location = url;
    }
    if (error) setShowModal(true);
  }, [url, error]);

  return (
    <div id={"__iframe_modal"} className="c-modal" aria-hidden={!showModal}>
      <div className="c-modal__overlay" tabIndex="-1"></div>
      <div
        className="c-modal__wrapper"
        role="dialog"
        aria-labelledby={"lblbyId___iframe_modal"}
      >
        <div className="c-modal__header">
          <button
            className="c-modal__close-btn __fsov_button_iframehelper"
            onClick={() => closeModal(false)}
            type="button"
            aria-label="Cerrar"
          ></button>
        </div>
        <div key={iFrameKey} className="c-modal__content" role="document">
          {error || url ? (
            url ? (
              <iframe
                className={"__fsov_IframeSection"}
                title="simulator"
                name="__fsov_Iframe"
                width="100%"
                height="650"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
              />
            ) : (
              <div className={"__fsov_IframeSection"}>
                <div>
                  <h4 className={"u-text-center"}>{error}</h4>
                </div>
              </div>
            )
          ) : (
            <div className={"__fsov_IframeSection"}>
              <div>
                <h4 className={"u-text-center"}>{mensaje}</h4>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

ModalIframe.propTypes = {
  url: PropTypes.string.isRequired,
  mensaje: PropTypes.string.isRequired,
};
